import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import ReactGA from "react-ga";
import { AppContext, isValidJSONString } from "./utils/utils";

import indexRoutes from "./routes/index.jsx";
import { GA_TRACKING_ID } from "./constants";

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    ReactGA.pageview(location.pathname);
  }, [location]);
}

const AppSwitch = (props) => {
  usePageViews();
  return (
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} key={key} component={prop.component} />;
      })}
    </Switch>
  );
};

class App extends Component {
  constructor(props) {
    super(props);
    this.setUserInfo = (info) => {
      localStorage.setItem(
        "BINDBOX_userInfo",
        JSON.stringify(this.state.userInfo)
      );
      this.setState({ userInfo: info });
    };
    const savedUserInfo = localStorage.getItem("BINDBOX_userInfo");
    this.state = {
      userInfo:
        savedUserInfo && isValidJSONString(savedUserInfo)
          ? JSON.parse(savedUserInfo)
          : null,
      setUserInfo: this.setUserInfo,
    };
  }

  componentDidMount() {
    ReactGA.initialize(GA_TRACKING_ID, {
      debug: process.env.NODE_ENV !== "production",
      titleCase: false,
      gaOptions: {
        userId: this.state.userInfo ? this.state.userInfo.id : "555",
      },
    });
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        <Router>
          <AppSwitch />
        </Router>
      </AppContext.Provider>
    );
  }
}

export default App;
